<script setup lang="ts">
  import AuditLog from '@/common/components/auditlog/AuditLog.vue'
  import ModalFrame from '@/common/components/modal/ModalFrame.vue'
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from '@/store'

  const route = useRoute()
  const store = useStore()

  const id = computed(() => route.params.id ? String(route.params.id) : undefined)
  const type = computed(() => route.name === 'systemTreeNodeAuditLog' ? 'systemtree' : undefined)

  function close () {
    store.commit('app/setAuditLogVisible', false)
  }
</script>

<template>
  <ModalFrame :title="$t('auditlog.singular')" :useModalStack="$route.name === 'systemTreeNodeAuditLog'" @close="close">
    <AuditLog
      :entityId="id"
      :entityType="type"
    />
  </ModalFrame>
</template>